<template>
  <b-modal id="classesRemoveModal"
           class="classesRemoveModal"
           size="xl"
  >
    <template #modal-title>
      <h5>
        <em class="fas fa-times-circle"></em> Удаление классов
      </h5>
    </template>

    <template #default>
      <b-alert show="" variant="danger">
        Вместе с классом будут удалены пользователи, а так же весь связанный контент
        (записи о классе, мероприятия класса), класс будет удален с карты на главной странице.
      </b-alert>
      <div class="table" style="width: 100%; height: 40vh;">
        <ag-grid-vue
          class="remove-modal-grid ag-theme-material"
          :gridOptions="gridOptions"
          :rowData="chosenClasses"
          :columnDefs="columnDefs"
          @onGridReady="onGridReady"
        >
        </ag-grid-vue>
      </div>
    </template>

    <template #modal-footer>
      <b-button cols="auto" @click="onSubmit"  variant="primary">
        <em class="fas fa-times-circle"></em> Удалить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapActions } from 'vuex'
import organizationApi from '@/api/organization'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'ClassesRemoveModal',
  data() {
    return {
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          headerClass: 'classes-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        localeText: AG_GRID_LOCALE_RU,
        pagination: true,
        paginationPageSize: 20,
        rowHeight: 90,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      columnDefs: [
        {
          headerName: 'Название',
          field: 'title',
          width: 300
        },
        {
          headerName: 'Город',
          field: 'city'
        },
        {
          headerName: 'Адрес',
          field: 'address',
          width: 300
        },
        {
          headerName: 'Год',
          field: 'year',
          width: 110
        },
        {
          headerName: 'Сайт',
          field: 'siteUrl'
        }
      ]
    }
  },
  props: {
    chosenClasses: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.setDomLayout('autoHeight')
    },
    onSubmit() {
      organizationApi.removeOrganizations(this.chosenClasses)
        .then(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Класс успешно удален.'
          })
          this.$bvModal.hide('classesRemoveModal')
          this.$emit('classesRemoved')
        })
        .catch(() => {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Ошибка удаления класса. '
          })
        })
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  },
  components: {
    'ag-grid-vue': AgGridVue
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/vendor/bootstrap/variables";

.remove-modal-grid {
  width: 100%;
  height: 100%;
}

.classesRemoveModal .table {
  justify-content: left;
}

.ag-theme-alpine {
  width: 100% !important;
  height: 20% !important;
}

.modal-footer {
  border: 0;
}

.classesRemoveModal .ag-row .ag-cell {
  justify-content: left;
  text-align: left;
}
.classesRemoveModal .ag-header-cell-label {
  justify-content: left;
}
</style>
